import { Dispatch, SetStateAction, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

interface ErrorToastProps {
	errorMessages: string[];
	isError: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	open: boolean;
}

const ErrorToast: React.FC<ErrorToastProps> = ({ errorMessages, isError, setOpen, open }) => {
	const [show, setShow] = useState(isError);

	const handleClose = () => setShow(false);

	return (
		<ToastContainer className="mx-auto mt-20 p-3" position="top-center">
			<Toast
				bg="danger"
				onClose={() => {
					setOpen(false);
				}}
				show={open}
				delay={10000}
			>
				<Toast.Header>
					<strong className="me-auto">Error in inputting following fields</strong>
				</Toast.Header>
				<Toast.Body>
					<ul className="text-[0.6rem]">
						{errorMessages.map((error, index) => (
							<li key={index}>{error}</li>
						))}
					</ul>
				</Toast.Body>
			</Toast>
		</ToastContainer>
	);
};

export default ErrorToast;
